"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _loader = _interopRequireDefault(require("../../../../modalDispatcher/loader"));
var _selectors = require("./store/selectors");
var _constants = require("./store/constants");
var _SingleGalleryModal = _interopRequireDefault(require("./SingleGalleryModal"));
var _excluded = ["hotelID"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var showSigleGallery = (0, _loader.default)({
  key: _constants.SINGLE_GALLERY_MODAL_KEY,
  getModal: function getModal() {
    return Promise.resolve({
      default: _SingleGalleryModal.default
    });
  }
});
var withGalleryProps = function withGalleryProps(Component) {
  var WithGalleryProps = function WithGalleryProps(_ref) {
    var hotelID = _ref.hotelID,
      props = _objectWithoutProperties(_ref, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var photosCategoriesByHotelSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getPhotosCategoriesByHotel)(), [hotelID]);
    }, [hotelID]);
    var photosCategories = (0, _reactRedux.useSelector)(photosCategoriesByHotelSelector);
    var photosByCategoriesSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getPhotosByCategories)(), [hotelID]);
    }, [hotelID]);
    var photosByCategories = (0, _reactRedux.useSelector)(photosByCategoriesSelector);
    var photosSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getPhotos)(), [hotelID]);
    }, [hotelID]);
    var photos = (0, _reactRedux.useSelector)(photosSelector);
    var thumbsPhotosSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getThumbsPhotos)(), [hotelID]);
    }, [hotelID]);
    var thumbs = (0, _reactRedux.useSelector)(thumbsPhotosSelector);
    var watermarkSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getWatermark)(), [hotelID]);
    }, [hotelID]);
    var watermark = (0, _reactRedux.useSelector)(watermarkSelector);
    var handleClickByPhoto = (0, _react.useCallback)(function (selectedPhoto) {
      return dispatch(showSigleGallery(undefined, {
        initialActiveIndex: R.findIndex(function (thumb) {
          return R.endsWith(thumb, selectedPhoto);
        }, thumbs),
        photos: thumbs,
        watermark: watermark
      }));
    }, [dispatch, thumbs, watermark]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      categories: photosCategories,
      photos: photos,
      photosByCaregories: photosByCategories,
      onClickByPhoto: handleClickByPhoto
    }, props));
  };
  WithGalleryProps.propTypes = {
    hotelID: _propTypes.default.number.isRequired
  };
  return WithGalleryProps;
};
var _default = exports.default = withGalleryProps;